import React, { useState, useEffect, useRef } from 'react';
// import { useEditStore } from '../stores';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import moment from 'moment';
import ExampleColorPickerView from './exampleColorPickerView';
import reactCSS from 'reactcss';

export function DetailContent(data) {
  const [load, setLoad] = useState(false);
  // const [styleLoad, setStyleLoad] = useState(false);
  const [getstyles, setGetstyles] = useState(
    reactCSS({
      default: {
        paperColor: {
          color: '',
        },
        bgPaperColor: {
          background: '',
        },
        questionColor: {
          color: '',
        },
        answerColor: {
          color: '',
        },
        stripColor: {
          background: '',
        },
        buttonBgColor: {
          color: '',
        },
        fontStyle: {
          fontFamily: '',
        },
      },
    })
  );

  const themes = useSelector((state) => state.redTheme);
  console.log('ini single theme', themes);
  useEffect(() => {
    const load = setTimeout(() => {
      setLoad(true);
    }, 1000);
    return () => clearTimeout(load);
  }, [data]);
  useEffect(() => {
    const styleLoad = setTimeout(() => {
      setGetstyles(
        reactCSS({
          default: {
            paperColor: {
              background: `${themes.style.paperColor}`,
            },
            bgPaperColor: {
              background: `${themes.style.backgroundPaperColor}`,
            },
            questionColor: {
              color: `${themes.style.questionColor}`,
            },
            answerColor: {
              color: `${themes.style.answerColor}`,
            },
            stripColor: {
              background: `${themes.style.stripColor}`,
            },
            buttonBgColor: {
              color: `${themes.style.backgroundButtonColor}`,
            },
            fontStyle: {
              fontFamily: `${themes.style.fontType}`,
            },
          },
        })
      );
    }, 3500);
    return () => clearTimeout(styleLoad);
  }, [data]);

  const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1024 });
    return isDesktop ? children : Default;
  };
  const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
    return isTablet ? children : null;
  };
  const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    return isMobile ? children : null;
  };
  const Default = ({ children }) => {
    const isNotTabletAndMobile = useMediaQuery({
      minWidth: 768,
      maxWidth: 990,
    });
    return isNotTabletAndMobile ? children : null;
  };

  const baseImg =
    'https://cdn.pixabay.com/photo/2017/06/09/07/42/flower-2386049_960_720.jpg';

  const handleImgError = (e) => {
    e.target.src = baseImg;
  };

  let contentUi = <div className='loader-block' />;

  if (load) {
    contentUi = (
      <>
        <Desktop>
          <div className=''>
            <div>
              <div className='bg-gray-400 rounded overflow-hidden shadow-md rounded-lg '>
                <div className='px-6 py-4'>
                  <div className='grid lg:grid-cols-5'>
                    <div className='px-4 rounded'>
                      <p className='text-lg text-white'>Gambar</p>
                    </div>

                    <div className='px-4 rounded'>
                      <p className='text-lg text-white'> Name</p>
                    </div>

                    <div className='px-4 rounded'>
                      <p className='text-lg text-white'>Type </p>
                    </div>

                    <div className='px-4 rounded'>
                      <p className='text-lg text-white'>Description</p>
                    </div>

                    <div className='px-4 rounded'>
                      <p className='text-lg text-white'>Created At</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='bg-white rounded overflow-hidden shadow-md rounded-lg mb-4 px-4 py-4'>
                <div className='grid  lg:grid-cols-5'>
                  <div className='px-4  bg-white flex items-center rounded'>
                    <div className='rounded sm:w-36 sm:h-36 md:w-36 md:h-36 xl:w-36 xl:h-36 2xl:w-36 2xl:h-36'>
                      <img
                        src={themes.selectedFile}
                        onError={handleImgError}
                        alt='themes-avatar'
                        className='object-cover h-32 rounded-lg'
                      />
                    </div>
                  </div>
                  <div className='px-4  bg-white flex items-center rounded'>
                    {/* <Link to={`/themes-management/detail/${themes.id}`}> */}
                    <p className='font-bold text-left '>{themes.name}</p>
                    {/* </Link> */}
                  </div>
                  <div className='px-4  bg-white flex items-center rounded'>
                    <p className='font-bold'>{themes.type}</p>
                  </div>
                  <div className='px-4 bg-white flex items-center rounded'>
                    <p className=''>{themes.description}</p>
                  </div>

                  <div className='px-4  bg-white flex items-center rounded'>
                    {/* <p className='font-bold'>{themes.createdAt}</p> */}
                    <div>
                      <p className='font-bold'>
                        {moment(`${themes.createdAt}`, 'YYYYMMDDHHmm').format(
                          'HH:mm A'
                        )}
                      </p>
                      {/* <br /> */}
                      <p className='text-xs'>
                        {moment(`${themes.createdAt}`, 'YYYYMMDDHHmm').format(
                          'DD/MM/YYYY'
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='bg-gray-400 rounded overflow-hidden shadow-md rounded-lg mt-10'>
              <div className='px-6 py-4'>
                <div className=''>
                  <h3 className='text-white'> &#128640; PREVIEW</h3>
                </div>
              </div>
            </div>
            {getstyles ? (
              <div
                className='overflow-hidden border-2 rounded px-4 py-4 flex-auto'
                style={getstyles.bgPaperColor}
              >
                <div className='px-6 py-4 content-box flex-col justify-center items-center rounded overflow-y-scroll'>
                  <ExampleColorPickerView
                    paperBg={getstyles.paperColor}
                    questionColor={getstyles.questionColor}
                    answerColor={getstyles.answerColor}
                    stripColor={getstyles.stripColor}
                    fontType={getstyles.fontStyle}
                    buttonColor={getstyles.buttonBgColor}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </Desktop>

        <Tablet>
          <div className=''>
            <div>
              <div className='bg-gray-400 rounded overflow-hidden shadow-md rounded-lg mt-10'>
                <div className='px-6 py-4'>
                  <div className=''>
                    <h4 className='text-white'> &#128640; ABOUT</h4>
                  </div>
                </div>
              </div>
              <div className='bg-white rounded overflow-hidden shadow-md rounded-lg mb-4 px-4 py-4'>
                <div className='grid  lg:grid-cols-5'>
                  <div className='px-4  bg-white flex items-center rounded'>
                    <div className='rounded sm:w-36 sm:h-36 md:w-36 md:h-36 xl:w-36 xl:h-36 2xl:w-36 2xl:h-36'>
                      <img
                        src={themes.selectedFile}
                        onError={handleImgError}
                        alt='themes-avatar'
                        className='object-cover h-32 rounded-lg'
                      />
                    </div>
                  </div>
                  <div className='px-4  bg-white flex items-center rounded'>
                    {/* <Link to={`/themes-management/detail/${themes.id}`}> */}
                    <p className='font-bold text-left '>{themes.name}</p>
                    {/* </Link> */}
                  </div>
                  <div className='px-4  bg-white flex items-center rounded'>
                    <p className='font-bold'>{themes.type}</p>
                  </div>
                  <div className='px-4 bg-white flex items-center rounded'>
                    <p className=''>{themes.description}</p>
                  </div>

                  <div className='px-4  bg-white flex items-center rounded'>
                    {/* <p className='font-bold'>{themes.createdAt}</p> */}
                    <div>
                      <p className='font-bold'>
                        {moment(`${themes.createdAt}`, 'YYYYMMDDHHmm').format(
                          'HH:mm A'
                        )}
                      </p>
                      {/* <br /> */}
                      <p className='text-xs'>
                        {moment(`${themes.createdAt}`, 'YYYYMMDDHHmm').format(
                          'DD/MM/YYYY'
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='bg-gray-400 rounded overflow-hidden shadow-md rounded-lg mt-10'>
              <div className='px-6 py-4'>
                <div className=''>
                  <h4 className='text-white'> &#128640; PREVIEW</h4>
                </div>
              </div>
            </div>
            {getstyles ? (
              <div
                className='overflow-hidden border-2 rounded px-4 py-4 flex-auto'
                style={getstyles.bgPaperColor}
              >
                <div className='px-6 py-4 content-box flex-col justify-center items-center rounded overflow-y-scroll'>
                  <ExampleColorPickerView
                    paperBg={getstyles.paperColor}
                    questionColor={getstyles.questionColor}
                    answerColor={getstyles.answerColor}
                    stripColor={getstyles.stripColor}
                    fontType={getstyles.fontStyle}
                    buttonColor={getstyles.buttonBgColor}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </Tablet>
        <Mobile>
          <div className=''>
            <div>
              <div className='bg-gray-400 rounded overflow-hidden shadow-md rounded-lg mt-2'>
                <div className='px-6 py-4'>
                  <div className=''>
                    <h4 className='text-white'> &#128640; ABOUT</h4>
                  </div>
                </div>
              </div>
              <div className='bg-white mx-auto overflow-hidden shadow-md rounded-lg mb-4 px-4 py-4 space-y-2'>
                <div className='bg-white flex items-center rounded'>
                  <div className='rounded w-full'>
                    <img
                      src={themes.selectedFile}
                      onError={handleImgError}
                      alt='themes-avatar'
                      className='object-cover h-32 rounded-lg w-full'
                    />
                  </div>
                </div>
                <div className='px-4  bg-white flex items-center rounded'>
                  {/* <Link to={`/themes-management/detail/${themes.id}`}> */}
                  <p className='font-bold text-left '>{themes.name}</p>
                  {/* </Link> */}
                </div>
                <hr />
                <div className='px-4  bg-white flex items-center rounded'>
                  <p className='font-bold'>{themes.type}</p>
                </div>
                 <hr />
                <div className='px-4 bg-white flex items-center rounded'>
                  <p className=''>{themes.description}</p>
                </div>
                 <hr />

                <div className='px-4  bg-white flex items-center rounded'>
                  {/* <p className='font-bold'>{themes.createdAt}</p> */}
                  <div>
                    <p className='font-bold'>
                      {moment(`${themes.createdAt}`, 'YYYYMMDDHHmm').format(
                        'HH:mm A'
                      )}
                    </p>
                    {/* <br /> */}
                    <p className='text-xs'>
                      {moment(`${themes.createdAt}`, 'YYYYMMDDHHmm').format(
                        'DD/MM/YYYY'
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className='bg-gray-400 rounded overflow-hidden shadow-md rounded-lg mt-10'>
              <div className='px-6 py-4'>
                <div className=''>
                  <h4 className='text-white'> &#128640; PREVIEW</h4>
                </div>
              </div>
            </div>
            {getstyles ? (
              <div
                className='overflow-hidden border-2 rounded px-4 py-4 flex-auto'
                style={getstyles.bgPaperColor}
              >
                <div className='px-6 py-4 content-box flex-col justify-center items-center rounded overflow-y-scroll'>
                  <ExampleColorPickerView
                    paperBg={getstyles.paperColor}
                    questionColor={getstyles.questionColor}
                    answerColor={getstyles.answerColor}
                    stripColor={getstyles.stripColor}
                    fontType={getstyles.fontStyle}
                    buttonColor={getstyles.buttonBgColor}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </Mobile>
      </>
    );
  }

  return contentUi;
}
